export default __webpack_public_path__ + "static/media/SFProText-Regular.90da7ab1.ttf";